import React, { useState } from 'react'

import clsx from 'clsx'

import Icon from 'components/Icon'
import { useEventContext } from 'context/EventContext'

import classes from './GoodRecommendations.module.scss'

const GoodRecommendations = () => {
  const eventContext = useEventContext({ engagementComponent: 'user-feedback' })
  const [isThumbsUpClicked, setIsThumbsUpClicked] = useState(false)
  const [isThumbsDownClicked, setIsThumbsDownClicked] = useState(false)

  return (
    <div className={clsx('GoodRecommendations', classes.root)}>
      <p className={classes.text}>
        {isThumbsUpClicked || isThumbsDownClicked ? 'Thank you!' : 'Good recommendations?'}
      </p>
      <div className={classes.buttons}>
        {isThumbsUpClicked ? (
          <button className={clsx(classes.button, classes.thumbsUpClickedButton)} type="button">
            <Icon className={classes.thumbsUpClickedIcon} icon={['fas', 'thumbs-up']} />
          </button>
        ) : (
          <button
            className={clsx(classes.button, classes.thumbsUpButton, {
              disabled: isThumbsDownClicked,
            })}
            type="button"
            {...eventContext.addEvent({
              engagementDestination: 'thumbs-up',
              engagementDetails: 'icon_thumbs-up',
              name: 'engagement_facet_click',
            })}
            onClick={() => {
              setIsThumbsUpClicked(true)
            }}
          >
            <Icon className={classes.thumbsUpIcon} icon={['fal', 'thumbs-up']} />
          </button>
        )}
        {isThumbsDownClicked ? (
          <button className={clsx(classes.button, classes.thumbsDownClickedButton)} type="button">
            <Icon className={classes.thumbsDownClickedIcon} icon={['fas', 'thumbs-down']} />
          </button>
        ) : (
          <button
            className={clsx(classes.button, classes.thumbsDownButton, {
              disabled: isThumbsUpClicked,
            })}
            type="button"
            {...eventContext.addEvent({
              engagementDestination: 'thumbs-down',
              engagementDetails: 'icon_thumbs-down',
              name: 'engagement_facet_click',
            })}
            onClick={() => {
              setIsThumbsDownClicked(true)
            }}
          >
            <Icon className={classes.thumbsDownIcon} icon={['fal', 'thumbs-down']} />
          </button>
        )}
      </div>
    </div>
  )
}

export default GoodRecommendations
